(() => {
  const root = document.querySelector('[data-lr-home]');
  if (!root || root.dataset.enhanced === 'true') return;
  root.dataset.enhanced = 'true';
  root.classList.add('lr-animate');

  const items = root.querySelectorAll('.lr-reveal');
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  items.forEach((item) => observer.observe(item));
})();
